import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import AuthLayout from '@/views/Pages/AuthLayout.vue';
// GeneralViews
import NotFound from '@/views/GeneralViews/NotFoundPage.vue';

// Calendar
const Calendar = () => import(/* webpackChunkName: "extra" */ '@/views/Calendar/Calendar.vue');
// Charts
const Charts = () => import(/* webpackChunkName: "dashboard" */ '@/views/Charts.vue');

// Components pages
const Buttons = () => import(/* webpackChunkName: "components" */ '@/views/Components/Buttons.vue');
const Cards = () => import(/* webpackChunkName: "components" */ '@/views/Components/Cards.vue');
const GridSystem = () => import(/* webpackChunkName: "components" */ '@/views/Components/GridSystem.vue');
const Notifications = () => import(/* webpackChunkName: "components" */ '@/views/Components/Notifications.vue');
const Icons = () => import(/* webpackChunkName: "components" */ '@/views/Components/Icons.vue');
const Typography = () => import(/* webpackChunkName: "components" */ '@/views/Components/Typography.vue');

// Dashboard pages
const Dashboard = () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard/Dashboard.vue');
const AlternativeDashboard = () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard/AlternativeDashboard.vue');
const Widgets = () => import(/* webpackChunkName: "dashboard" */ '@/views/Widgets.vue');

// Forms pages
const FormElements = () => import(/* webpackChunkName: "forms" */ '@/views/Forms/FormElements.vue');
const FormComponents = () => import(/* webpackChunkName: "forms" */ '@/views/Forms/FormComponents.vue');
const FormValidation = () => import(/* webpackChunkName: "forms" */ '@/views/Forms/FormValidation.vue');

// Maps pages
const GoogleMaps = () => import(/* webpackChunkName: "extra" */ '@/views/Maps/GoogleMaps.vue');
const VectorMaps = () => import(/* webpackChunkName: "extra" */ '@/views/Maps/VectorMaps.vue');

// Pages
const User = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/UserProfile.vue');
const Pricing = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Pricing.vue');
const TimeLine = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/TimeLinePage.vue');
const Login = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Login.vue');
const Home = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Home.vue');
const Register = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Register.vue');
const Lock = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Lock.vue');

// TableList pages
const RegularTables = () => import(/* webpackChunkName: "tables" */ '@/views/Tables/RegularTables.vue');
const SortableTables = () => import(/* webpackChunkName: "tables" */ '@/views/Tables/SortableTables.vue');
const PaginatedTables = () => import(/* webpackChunkName: "tables" */ '@/views/Tables/PaginatedTables.vue');


//EC Pages

const EcDashboard = () => import(/* webpackChunkName: "ec" */ '@/views/EC/EcDashboard.vue');
const Officers = () => import(/* webpackChunkName: "ec" */ '@/views/EC/Officers.vue');
const Shareholders = () => import(/* webpackChunkName: "ec" */ '@/views/EC/Shareholders.vue');
const Logout = () => import(/* webpackChunkName: "ec" */ '@/views/EC/Logout.vue');
const KeyDocuments = () => import(/* webpackChunkName: "ec" */ '@/views/EC/KeyDocuments.vue');
const Timeline = () => import(/* webpackChunkName: "ec" */ '@/views/EC/Timeline.vue');
const ViewDocument = () => import(/* webpackChunkName: "ec" */ '@/views/EC/ViewDocument.vue');
const Invoices = () => import(/* webpackChunkName: "ec" */ '@/views/EC/Invoices.vue');
const ViewInvoice = () => import(/* webpackChunkName: "ec" */ '@/views/EC/ViewInvoice.vue');
const EcSelector = () => import(/* webpackChunkName: "ec" */ '@/views/EC/EcSelector.vue');
const Requests = () => import(/* webpackChunkName: "ec" */ '@/views/EC/Requests.vue');
const CreateRequest = () => import(/* webpackChunkName: "ec" */ '@/views/EC/CreateRequest.vue');
const CreateRequestDetails = () => import(/* webpackChunkName: "ec" */ '@/views/EC/CreateRequestDetails.vue');
const ViewRequest = () => import(/* webpackChunkName: "ec" */ '@/views/EC/ViewRequest.vue');
const ViewRequestDocument = () => import(/* webpackChunkName: "ec" */ '@/views/EC/ViewRequestDocument.vue');
const Onboarding = () => import(/* webpackChunkName: "ec" */ '@/views/EC/Onboarding.vue');
const OnboardingIncorp = () => import(/* webpackChunkName: "ec" */ '@/views/EC/OnboardingIncorp.vue');
const OnboardingRedirect = () => import(/* webpackChunkName: "ec" */ '@/views/EC/OnboardingRedirect.vue');
const NameChecker = () => import(/* webpackChunkName: "ec" */ '@/views/EC/NameChecker.vue');
const OnboardingAppointInit = () => import(/* webpackChunkName: "ec" */ '@/views/EC/OnboardingAppointInit.vue');
const OnboardingAppoint = () => import(/* webpackChunkName: "ec" */ '@/views/EC/OnboardingAppoint.vue');
const OnboardingIncorpInit = () => import(/* webpackChunkName: "ec" */ '@/views/EC/OnboardingIncorpInit.vue');
const ChangePassword = () => import(/* webpackChunkName: "ec" */ '@/views/EC/ChangePassword.vue');
const VerifyEmail = () => import(/* webpackChunkName: "ec" */ '@/views/EC/VerifyEmail.vue');
const EditContactPerson = () => import(/* webpackChunkName: "ec" */ '@/views/EC/EditContactPerson.vue');
const ForgotPassword = () => import(/* webpackChunkName: "ec" */ '@/views/EC/ForgotPassword.vue');
const ResetPassword = () => import(/* webpackChunkName: "ec" */ '@/views/EC/ResetPassword.vue');
const DigitalMailbox = () => import(/* webpackChunkName: "ec" */ '@/views/EC/DigitalMailbox.vue');
const ViewMail = () => import(/* webpackChunkName: "ec" */ '@/views/EC/ViewMail.vue');
const ComplianceForm = () => import(/* webpackChunkName: "ec" */ '@/views/EC/ComplianceForm.vue');
const Documents = () => import(/* webpackChunkName: "ec" */ '@/views/EC/Documents.vue');
const ViewFolder = () => import(/* webpackChunkName: "ec" */ '@/views/EC/ViewFolder.vue');



let componentsMenu = {
  path: '/components',
  component: DashboardLayout,
  redirect: '/components/buttons',
  name: 'Components',
  children: [
    {
      path: 'buttons',
      name: 'Buttons',
      component: Buttons
    },
    {
      path: 'cards',
      name: 'Cards',
      component: Cards
    },
    {
      path: 'grid-system',
      name: 'Grid System',
      component: GridSystem
    },
    {
      path: 'notifications',
      name: 'Notifications',
      component: Notifications
    },
    {
      path: 'icons',
      name: 'Icons',
      component: Icons
    },
    {
      path: 'typography',
      name: 'Typography',
      component: Typography
    }
  ]
};
let formsMenu = {
  path: '/forms',
  component: DashboardLayout,
  redirect: '/forms/elements',
  name: 'Forms',
  children: [
    {
      path: 'elements',
      name: 'Form elements',
      component:  FormElements
    },
    {
      path: 'components',
      name: 'Form components',
      component:  FormComponents
    },
    {
      path: 'validation',
      name: 'Form validation',
      component:  FormValidation
    }
  ]
};

let tablesMenu = {
  path: '/tables',
  component: DashboardLayout,
  redirect: '/table/regular',
  name: 'Tables menu',
  children: [
    {
      path: 'regular',
      name: 'Tables',
      component: RegularTables
    },
    {
      path: 'sortable',
      name: 'Sortable',
      component: SortableTables
    },
    {
      path: 'paginated',
      name: 'Paginated Tables',
      component: PaginatedTables
    }
  ]
};

let mapsMenu = {
  path: '/maps',
  component: DashboardLayout,
  name: 'Maps',
  redirect: '/maps/google',
  children: [
    {
      path: 'google',
      name: 'Google Maps',
      component: GoogleMaps
    },
    {
      path: 'vector',
      name: 'Vector Map',
      component: VectorMaps
    }
  ]
};

let pagesMenu = {
  path: '/pages',
  component: DashboardLayout,
  name: 'Pages',
  redirect: '/pages/user',
  children: [
    {
      path: 'user',
      name: 'User Page',
      component: User
    },
    {
      path: 'timeline',
      name: 'Timeline Page',
      component: TimeLine
    }
  ]
};

let authPages = {
  path: '/',
  component: AuthLayout,
  name: 'Authentication',
  children: [
    {
      path: '/register',
      name: 'Register',
      component: Register,
      meta: {
        public: true,  // Allow access to even if not logged in
        onlyWhenLoggedOut: true
  	  }
    },
    {
      path: '/forgot-password',
      name: 'Forgot Password',
      component: ForgotPassword,
      meta: {
        public: true,  // Allow access to even if not logged in
        onlyWhenLoggedOut: true
  	  }
    },
     {
      path: '/reset-password/:token',
      name: 'Reset Password',
      component: ResetPassword,
      meta: {
        public: true,  // Allow access to even if not logged in
        onlyWhenLoggedOut: true
  	  }
    },
     {
      path: '/verify-email/:cid/:sig',
      name: 'Verify Email',
      component: VerifyEmail,
      meta: {
        public: true,  // Allow access to even if not logged in
  	  }
    },
    {
      path: '/compliance-form/:cfid/:sig',
      name: 'Compliance',
      component: ComplianceForm,
      meta: {
        public: true,  // Allow access to even if not logged in
  	  }
    },
    {
      path: '/pricing',
      name: 'Pricing',
      component: Pricing
    },
    
    {
 	 path: '/login',
 	 name: 'Login',
 	 component: Login,
 	 meta: {
        public: true,  // Allow access to even if not logged in
        onlyWhenLoggedOut: true
	 }
	},
    {
      path: '/lock',
      name: 'Lock',
      component: Lock
    },
    { path: '*', component: NotFound }
  ]
};




const routes = [
  {
    path: '/',
    redirect: '/ec_dashboard',
    name: 'Home'
  },
  {
    path: '/ec-selector',
    name: 'Select Your Company',
    component: EcSelector
  },
   
  componentsMenu,
  formsMenu,
  tablesMenu,
  mapsMenu,
  pagesMenu,
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/ec_dashboard',
    name: 'Dashboard layout',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard
      },
      {
        path: 'alternative',
        name: 'Alternative',
        component: AlternativeDashboard,
        meta: {
          navbarType: 'light'
        }
      },
      {
        path: 'calendar',
        name: 'Calendar',
        component: Calendar
      },
      {
        path: 'charts',
        name: 'Charts',
        component: Charts
      },
      {
        path: 'widgets',
        name: 'Widgets',
        component: Widgets
      },
      
      {
        path: 'ec_dashboard',
        name: 'EC Dashboard',
        component: EcDashboard
      },
       {
        path: 'officers',
        name: 'Officers',
        component: Officers
      },
       {
        path: 'shareholders',
        name: 'Shareholders',
        component: Shareholders
      },
        {
        path: 'logout',
        name: 'Logout',
        component: Logout
      },
        {
        path: 'key_documents',
        name: 'Key Documents',
        component: KeyDocuments
      },
       {
        path: 'timeline',
        name: 'Timeline',
        component: Timeline
      },
      {
        path: 'view-document/:did/:type',
        name: 'View Document',
        component: ViewDocument
      },
      {
        path: 'billing',
        name: 'Billing',
        component: Invoices
      },
       {
        path: 'requests',
        name: 'Requests',
        component: Requests
      },
       {
        path: 'create-request',
        name: 'Create A New Request',
        component: CreateRequest
      },
       {
        path: 'create-request-details/:type',
        name: 'Create A New Request - Details',
        component: CreateRequestDetails
      },
       {
        path: 'view-request/:rid',
        name: 'View Request',
        component: ViewRequest
      },
      {
        path: 'view-request-document/:did',
        name: 'View Request Document',
        component: ViewRequestDocument
      },
       {
        path: 'view-invoice/:iid',
        name: 'View Invoice',
        component: ViewInvoice
      },
      {
        path: 'onboarding',
        name: 'Onboarding',
        component: Onboarding
      },
       {
        path: 'incorporation',
        name: 'Onboarding - Incorp',
        component: OnboardingIncorp
      },
      {
        path: 'onboarding-redirect',
        name: 'Onboarding - Redirect',
        component: OnboardingRedirect
      },
      {
        path: 'name-checker',
        name: 'Company Name Checker',
        component: NameChecker
      },
      {
        path: 'onboarding-appoint-form',
        name: 'Onboarding - Appoint Company Secretary',
        component: OnboardingAppointInit
      },
      {
        path: 'onboarding-appoint-form-details',
        name: 'Onboarding - Appoint Company Secretary Form',
        component: OnboardingAppoint
      },
      {
        path: 'onboarding-incorp-form',
        name: 'Onboarding - Incorporation Of New Company',
        component: OnboardingIncorpInit
      },
       {
        path: 'change-password',
        name: 'Change Password',
        component: ChangePassword
      },
     
      {
        path: 'edit-contact-person',
        name: 'Edit Contact Person',
        component: EditContactPerson
      },
       {
        path: 'mailbox',
        name: 'Mailbox',
        component: DigitalMailbox
      },
      {
        path: 'view-mail/:mid',
        name: 'View Mail',
        component: ViewMail
      },
        {
        path: 'documents',
        name: 'Documents',
        component: Documents
      },
      {
        path: 'view-folder/:fid',
        name: 'View Folder',
        component: ViewFolder
      },
    ]
  },
  authPages,
];

export default routes;
